import {
  SchematicBuilderContext,
  useSchematicBuilderContext,
} from "../SchematicBuilderContext";
import { KindSelect } from "./util/KindSelect";

export interface ListableBuilderProps {
  showKindSelect?: boolean;
}

export function ListableBuilder({
  showKindSelect = true,
}: ListableBuilderProps) {
  const schematicBuilderContext = useSchematicBuilderContext();
  const { useSchematic, setSchematic } = schematicBuilderContext;
  const id = useSchematic((schematic) => schematic.id);

  return (
    <div className="listable-builder builder">
      <SchematicBuilderContext.Provider
        value={{
          ...schematicBuilderContext,
          useSchematic: (selector) =>
            useSchematic((schematic) => selector(schematic.children![0])),
          setSchematic: (toSet) =>
            setSchematic((schematic) => ({
              ...schematic,
              children: [
                {
                  ...schematic.children![0],
                  ...(typeof toSet === "function"
                    ? toSet(schematic.children![0])
                    : toSet),
                },
              ],
            })),
          removeSchematic: () => {},
          parentId: id,
        }}
      >
        <ListableItemBuilder showKindSelect={showKindSelect} />
      </SchematicBuilderContext.Provider>
    </div>
  );
}

export function ListableBuilderWithoutKindSelect() {
  return <ListableBuilder showKindSelect={false} />;
}

export type ListableItemBuilderProps = ListableBuilderProps;

export function ListableItemBuilder({
  showKindSelect = true,
}: ListableItemBuilderProps) {
  const { schematicKinds, useSchematic } = useSchematicBuilderContext();
  const kind = useSchematic((schematic) => schematic.kind);
  const Builder = schematicKinds.get(kind)?.builder;

  return (
    <>
      {showKindSelect && <KindSelect />}
      {Builder && <Builder />}
    </>
  );
}
